<template>
  <div>
    <a-menu v-model:selectedKeys="selectedKeys" :open-keys="openKeys" theme="light" mode="inline">
      <a-menu-item key="dashboard">
        <router-link to="/">
          <DesktopOutlined />
          <span>工作台</span>
        </router-link>
      </a-menu-item>
      <a-sub-menu key="site_group" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>站群管理</template>
        <a-menu-item key="/siteGroup">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/siteGroup">站点列表</router-link>
        </a-menu-item>
        <a-menu-item key="pageSeo">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/pageSeo">页面SEO</router-link>
        </a-menu-item>
        <a-menu-item key="/siteTemplate">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/siteTemplate">模板管理</router-link>
        </a-menu-item>
        <a-menu-item key="/diy">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/diy">DIY研究</router-link>
        </a-menu-item>
      </a-sub-menu>

      <a-sub-menu key="article_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>文章管理</template>
        <a-menu-item key="/articleCategory">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/articleCategory">文章分类</router-link>
        </a-menu-item>
        <a-menu-item key="/article">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/article">文章列表</router-link>
        </a-menu-item>
      </a-sub-menu>

      <a-sub-menu key="ai_article" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>AI文案</template>
        <a-menu-item key="/aiArticle">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/aiArticle">AI文章</router-link>
        </a-menu-item>
        <a-menu-item key="/aiPrompt">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/aiPrompt">AI提示词</router-link>
        </a-menu-item>
      </a-sub-menu>

      <a-sub-menu key="goods_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>商品管理</template>
        <a-menu-item key="/goodsCategory">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/goodsCategory">商品分类</router-link>
        </a-menu-item>
        <a-menu-item key="/goods">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/goods">商品列表</router-link>
        </a-menu-item>

      </a-sub-menu>
      <a-sub-menu key="product_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>产品管理</template>
        <a-menu-item key="/productCategory">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/productCategory">产品分类</router-link>
        </a-menu-item>
        <a-menu-item key="/product">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/product">产品列表</router-link>
        </a-menu-item>

      </a-sub-menu>

      <a-sub-menu key="ad_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>广告管理</template>
        <a-menu-item key="/adCategory">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/adCategory">广告分类</router-link>
        </a-menu-item>
        <a-menu-item key="/ad">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/ad">广告列表</router-link>
        </a-menu-item>
      </a-sub-menu>


      <a-sub-menu key="ai_site_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>AI站点管理</template>
        <a-menu-item key="/aiSiteCategory">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/aiSiteCategory">AI站点分类</router-link>
        </a-menu-item>
        <a-menu-item key="/aiSite">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/aiSite">AI站点列表</router-link>
        </a-menu-item>

      </a-sub-menu>


      <a-sub-menu key="tag_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>标签管理</template>
        <a-menu-item key="/tagCategory">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/tagCategory">标签分类管理</router-link>
        </a-menu-item>
      </a-sub-menu>


      <a-sub-menu key="file_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>文件管理</template>
        <a-menu-item key="/file">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/file">文件列表</router-link>
        </a-menu-item>
        <a-menu-item key="/fileCategory">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/fileCategory">文件分类</router-link>
        </a-menu-item>
      </a-sub-menu>

      <a-sub-menu key="nav" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>导航菜单</template>
        <a-menu-item key="/nav">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/nav">导航菜单</router-link>
        </a-menu-item>

      </a-sub-menu>



      <a-sub-menu key="user" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>用户管理</template>
        <a-menu-item key="/user">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/user">用户列表</router-link>
        </a-menu-item>
      </a-sub-menu>



      <a-sub-menu key="system" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>系统管理</template>
        <a-menu-item key="/site">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/site">系统管理</router-link>
        </a-menu-item>
        <a-menu-item key="/admin">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/admin">管理员列表</router-link>
        </a-menu-item>

        <a-menu-item key="/system">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/system">系统设置列表</router-link>
        </a-menu-item>

      </a-sub-menu>


    </a-menu>
  </div>
</template>

<script setup>
import {
  DesktopOutlined,
  ProjectOutlined, ProfileOutlined, SolutionOutlined,RetweetOutlined,AuditOutlined,
  DatabaseOutlined,
  ContainerOutlined,FileOutlined,SettingOutlined,
  TeamOutlined,UserSwitchOutlined,
  FileMarkdownOutlined,ControlOutlined,
  RollbackOutlined,
} from '@ant-design/icons-vue';
import {reactive, ref} from "vue";
import {getQueryString} from "@/utils/common";
const selectedKeys = ref([])
const openKeys = reactive(['workorder'])
//
const pathname = window.location.pathname
selectedKeys.value = [pathname]
//查询上一级的key信息
const dataList = [
  {key:'article_category',path:'/articleCategory'},
  {key:'article_category',path:'/article'},
  {key:'goods_category',path:'/goodsCategory'},
  {key:'goods_category',path:'/goods'},
  {key:'product_category',path:'/productCategory'},
  {key:'product_category',path:'/product'},
  {key:'ad_category',path:'/adCategory'},
  {key:'ad_category',path:'/ad'},
  {key:'file_category',path:'/fileCategory'},
  {key:'file_category',path:'/file'},
  {key:'nav',path:'/nav'},
  {key:'user',path:'/user'},
  {key:'system',path:'/system'},
  {key:'system',path:'/site'},
  {key:'system',path:'/admin'},
  {key:'tag_category',path:'/tagCategory'},
  {key:'site_group',path:'/siteGroup'},
  {key:'site_group',path:'/pageSeo'},
  {key:'site_group',path:'/siteTemplate'},
  {key:'ai_article',path:'/aiArticle'},
  {key:'ai_article',path:'/aiPrompt'},
  {key:'ai_site_category',path:'/aiSiteCategory'},
  {key:'ai_site_category',path:'/aiSite'},
]
const fIndex = dataList.findIndex(t=>t.path === pathname)
if(fIndex >= 0){
  const fKey = dataList[fIndex]['key']
  let newKey = fKey
  if(fKey === '/store/task'){
    let typeParam = getQueryString('category_no')
    newKey = fKey+'?category_no='+typeParam
    Object.assign(openKeys, ['workorder',fKey,newKey]);
  }else {
    Object.assign(openKeys, ['workorder',newKey]);
  }

}
const titleClick = (e) => {
}
</script>

<style scoped>

</style>